import React from "react";
import { useLang } from "@/contexts/LangContext";
import PageMeta from "@/components/PageMeta";

export default function ImpressumPage() {
  const { t } = useLang();
  return (
    <div className="pt-32 pb-24" data-testid="imprint-page">
      <PageMeta pageKey="imprint" />
      <section className="max-w-screen-md mx-auto px-6 md:px-12">
        <p className="text-xs tracking-[0.3em] uppercase text-white/50 mb-6">{t("imprint.eyebrow")}</p>
        <h1 className="font-display text-4xl md:text-6xl font-light uppercase tracking-tighter leading-[0.95] mb-12">
          {t("imprint.title")}
        </h1>

        <div className="space-y-10 text-white/75 leading-relaxed">
          <Section title="Anbieter / Provider">
            <p>
              <strong className="text-white">Royalhouse Bauträger GmbH</strong>
              <br />
              Bäckerstraße 2/23
              <br />
              A-1010 Wien · Österreich
            </p>
          </Section>

          <Section title="Kontakt">
            <p>
              Telefon: <a className="rh-link" href="tel:+436643289599">+43 664 328 95 99</a>
              <br />
              E-Mail:{" "}
              <a className="rh-link" href="mailto:office@royalhouse-building.eu">
                office@royalhouse-building.eu
              </a>
              <br />
              E-Mail:{" "}
              <a className="rh-link" href="mailto:royalhouse.bautraeger@gmail.com">
                royalhouse.bautraeger@gmail.com
              </a>
              <br />
              Web:{" "}
              <a
                className="rh-link"
                href="https://www.royalhouse-bautraeger.com"
                target="_blank"
                rel="noreferrer noopener"
              >
                www.royalhouse-bautraeger.com
              </a>
            </p>
          </Section>

          <Section title="Unternehmensdaten">
            <p>
              UID-Nummer: <strong className="text-white">ATU77490127</strong>
              <br />
              Firmenbuchnummer: <strong className="text-white">FN 567208 f</strong>
              <br />
              Firmenbuchgericht: Handelsgericht Wien
              <br />
              Geschäftsführer: Johannes Fernberg
              <br />
              Gewerbeberechtigung: <span className="text-white/55">Bauträgergewerbe gem. § 117 GewO — Bescheid-Nr. wird ergänzt</span>
              <br />
              Kammerzugehörigkeit: Wirtschaftskammer Wien · Fachgruppe Bauträger
            </p>
          </Section>

          <Section title="Hinweis zu Projektinformationen">
            <p>
              Die auf dieser Website dargestellten Projekte, Visualisierungen, Pläne, Größen-
              und Ausstattungsangaben dienen ausschließlich der unverbindlichen Information.
              Sie stellen kein Angebot dar. Verbindliche Auskünfte erfolgen ausschließlich
              auf Basis projektbezogener schriftlicher Unterlagen (z. B. Kaufanbot, Vertrag,
              Beteiligungsdokumentation).
            </p>
          </Section>

          <Section title="Aufsichtsbehörde / Berufsrecht">
            <p>
              Magistratisches Bezirksamt für den 1. Bezirk, Wien
              <br />
              Anwendbares Recht: Gewerbeordnung (GewO),{" "}
              <a
                className="rh-link"
                href="https://www.ris.bka.gv.at"
                target="_blank"
                rel="noreferrer noopener"
              >
                ris.bka.gv.at
              </a>
            </p>
          </Section>

          <Section title="Mitgliedschaften">
            <p>
              Wirtschaftskammer Wien · Fachgruppe Bauträger
              <br />
              Kooperationspartner: Budova (UA), Well-Being ConTech, ECO Building Technik
              (Haustechnik & Lieferant), Ukraine Rebuilding Alliance
            </p>
          </Section>

          <Section title="Online-Streitbeilegung">
            <p>
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung
              (OS) bereit:{" "}
              <a
                className="rh-link"
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noreferrer noopener"
              >
                ec.europa.eu/consumers/odr
              </a>
            </p>
          </Section>

          <Section title="Haftungsausschluss">
            <p>
              Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für die
              Richtigkeit, Vollständigkeit und Aktualität wird jedoch keine Gewähr
              übernommen. Verlinkungen auf externe Seiten erfolgen nach bestem Wissen;
              für deren Inhalte sind ausschließlich deren Betreiber verantwortlich.
            </p>
          </Section>
        </div>
      </section>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <p className="text-[11px] tracking-[0.25em] uppercase text-white/50 mb-3">{title}</p>
      <div className="text-base">{children}</div>
    </div>
  );
}
